import React, { useState } from 'react';
import { Globe, Building, FileText } from 'lucide-react';

const ViewToggle = ({ viewState, setViewState }) => {
  const [isHovering, setIsHovering] = useState(false);
  
  // Debug logging
  console.log('ViewToggle rendered with viewState:', viewState);
  
  // Define the three states
  const states = ['business', 'site', 'response'];
  const stateLabels = {
    business: 'Business View',
    site: 'Site View',
    response: 'Response View'
  };
  


  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  // Calculate slider position based on state
  const getSliderPosition = () => {
    const index = states.indexOf(viewState);
    return `${index * 3}rem`;
  };

  return (
    <div style={{ position: 'relative' }}>
      <div style={{ 
        position: 'relative', 
        display: 'inline-block',
      }}>
        <div 
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          style={{
            position: 'relative',
            width: '9rem', // Increased width for three states
            height: '3rem',
            backgroundColor: 'white',
            borderRadius: '9999px',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            transition: 'all 300ms',
            overflow: 'hidden',
            border: '1px solid #e0e0e0',
          }}
        >
          <div 
            style={{
              position: 'absolute',
              top: 0,
              bottom: 0,
              width: '3rem',
              backgroundColor: '#667eea',
              borderRadius: '9999px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'left 300ms ease-in-out',
              overflow: 'hidden',
              maxHeight: '100%',
              left: getSliderPosition(),
            }}
          />
          
          {/* Globe Icon for Business View */}
          <button 
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              console.log('Business button clicked, current state:', viewState);
              if (setViewState && typeof setViewState === 'function') {
                setViewState('business');
              } else {
                console.error('setViewState is not a function:', setViewState);
              }
            }}
            style={{
              position: 'absolute',
              top: '0.5rem',
              left: '0.5rem',
              width: '2rem',
              height: '2rem',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              padding: 0,
              transition: 'opacity 300ms',
              opacity: viewState === 'business' ? 1 : 0.3,
              zIndex: 10,
            }}
          >
            <Globe size={32} color={viewState === 'business' ? "white" : "#2c3e50"} />
          </button>
          
          {/* Building Icon for Site View */}
          <button 
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              console.log('Site button clicked, current state:', viewState);
              if (setViewState && typeof setViewState === 'function') {
                setViewState('site');
              } else {
                console.error('setViewState is not a function:', setViewState);
              }
            }}
            style={{
              position: 'absolute',
              top: '0.5rem',
              left: '3.5rem',
              width: '2rem',
              height: '2rem',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              padding: 0,
              transition: 'opacity 300ms',
              opacity: viewState === 'site' ? 1 : 0.3,
              zIndex: 10,
            }}
          >
            <Building size={32} color={viewState === 'site' ? "white" : "#2c3e50"} />
          </button>
          
          {/* FileText Icon for Response View */}
          <button 
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              console.log('Response button clicked, current state:', viewState);
              if (setViewState && typeof setViewState === 'function') {
                setViewState('response');
              } else {
                console.error('setViewState is not a function:', setViewState);
              }
            }}
            style={{
              position: 'absolute',
              top: '0.5rem',
              right: '0.5rem',
              width: '2rem',
              height: '2rem',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              padding: 0,
              transition: 'opacity 300ms',
              opacity: viewState === 'response' ? 1 : 0.3,
              zIndex: 10,
            }}
          >
            <FileText size={32} color={viewState === 'response' ? "white" : "#2c3e50"} />
          </button>
        </div>
        
        {isHovering && (
          <div style={{
            position: 'absolute',
            bottom: '-40px',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: 'white',
            color: '#333333',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
            border: '1px solid #e0e0e0',
            padding: '0.5rem 1rem',
            borderRadius: '0.25rem',
            fontSize: '0.875rem',
            whiteSpace: 'nowrap',
            zIndex: 9999,
          }}>
            {stateLabels[viewState]}
          </div>
        )}
      </div>
    </div>
  );
};
export default ViewToggle;